<script>
export default {
    name: 'LoadingSpinner'
};
</script>

<template>
    <div class="series-selector__loading-spinner"><div></div><div></div><div></div><div></div></div>
</template>